<app-lazy-loaded-component [definition]="definition"></app-lazy-loaded-component>
